/**
 * ProductsPage - Wrapper для кэширования данных Товаров через React Query
 * НЕ изменяет логику Products.jsx, только кэширует API-запросы
 * 
 * Особенность: Products имеет пагинацию, поиск и фильтры - 
 * кэшируем только stats, products загружаются динамически
 */
import { useQuery } from "@tanstack/react-query";
import api from "@/utils/api";
import Products from "@/pages/Products";

// Функция для загрузки статистики (редко меняется)
const fetchProductStats = async () => {
  const response = await api.get("/catalog/stats/summary");
  return response.data;
};

export default function ProductsPage() {
  // Кэшируем только статистику - она редко меняется
  const statsQuery = useQuery({
    queryKey: ["productStats"],
    queryFn: fetchProductStats,
  });

  // Собираем данные для передачи в компонент
  const cachedData = {
    stats: statsQuery.data || null,
  };

  // Функция обновления кэша
  const refetchStats = async () => {
    await statsQuery.refetch();
  };

  // Передаём данные через props
  // Products загружает список товаров сам (есть пагинация/фильтры)
  return (
    <Products
      cachedData={cachedData}
      onRefetchStats={refetchStats}
    />
  );
}
